<template>
  <div class="flex" v-loading="loading">
    <div class="w-4/12 p-4">
      <div class="flex justify-end w-full py-4">
        <el-button
          @click.native="
            $router.push({
              name: 'DashboardMap',
              params: { id: `${mapId.Value}` }
            })
          "
          type="plain"
          >Go To Map</el-button
        >
      </div>

      <SvgMap
        class="pb-2"
        :view-box="viewBox"
        :loading="loading"
        :map-data="mapData"
        :control-icons="false"
        :dashboard-page="true"
        :height-map="'350px'"
        :width-map="'400px'"
      />
      <div class="flex">
        <div
          v-for="(label, index) of ['RACK', 'U SPACE']"
          :key="index"
          class="w-1/2 pb-2 border rounded"
          :class="index % 2 === 0 ? 'mr-1' : 'ml-1'"
        >
          <p class="mt-2 text-base font-bold text-center">
            {{ label }} UTILIZATION
          </p>
          <div class="flex justify-center px-2">
            <DoughnutChart
              v-if="chartDoughnutConsumptionVisible"
              style="width: 90%;"
              :height="500"
              :chart-data="dataCollectionDoughnuts[index]"
              :options="chartOptionsDoughnut"
            />
          </div>
          <div class="px-2">
            <!-- Available -->
            <div class="flex items-center justify-between px-1">
              <span>Available</span>
              <span class="text-xs font-bold"
                >{{ doughnutConsumptionInfo[index].available }}%</span
              >
            </div>
            <div class="h-4 bg-gray-300 rounded-lg">
              <div
                class="h-4 rounded-lg"
                :style="`width: ${doughnutConsumptionInfo[index].available}%`"
                style="
                  width: 40%;
                  background-image: linear-gradient(to right, #80cbc4, #4db6ac);
                "
              />
            </div>
            <!-- Consumed -->
            <div class="flex items-center justify-between px-1 mt-4">
              <span>Consumed</span>
              <span class="text-xs font-bold"
                >{{ doughnutConsumptionInfo[index].consumed }}%</span
              >
            </div>
            <div class="h-4 bg-gray-300 rounded-lg">
              <div
                class="h-4 rounded-lg"
                :style="`width: ${doughnutConsumptionInfo[index].consumed}%`"
                style="
                  width: 40%;
                  background-image: linear-gradient(to right, #b39ddb, #9575cd);
                "
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Water Leak Status -->
      <div class="mt-4 border p-8 text-center font-bold text-2xl rounded">
        <p>Current Water Leak Status:</p>
        <p class="mt-3" :class="getLeakClass(leakStatus)">{{ leakStatus }}</p>
      </div>
    </div>
    <div class="w-8/12">
      <TempAndHumidTrends />
      <div class="mt-4 mb-2 ml-1 text-base font-bold">UPS INFORMATION</div>
      <div class="flex w-full">
        <div v-for="btr of 1" :key="'btr-' + btr" class="w-2/4 mx-1">
          <div
            class="flex items-center justify-center w-full h-6 text-white bg-teal-600"
          >
            Battery Time Remaining
          </div>
          <div class="py-1">
            <line-chart
              style="width: 99%;"
              :height="200"
              :chart-data="dataCollectionLineBTR"
              :options="chartOptionsLineBTR"
            />
            <div class="px-2 py-1 border rounded">
              <div class="flex justify-between text-xs">
                <span>Min</span>
                <span>{{ timeRemainingDetail.min }} Min</span>
              </div>
              <div class="flex justify-between text-xs">
                <span>Max</span>
                <span>{{ timeRemainingDetail.max }} Min</span>
              </div>
              <div class="flex justify-between text-xs">
                <span>Avg</span>
                <span>{{ timeRemainingDetail.avg }} Min</span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="(util, index) of upsUtils"
          :key="'util-' + util"
          class="w-1/2 mx-1"
        >
          <div
            class="flex items-center justify-center w-full h-6 text-white bg-teal-600"
          >
            UPS {{ util.label }} Utilization
          </div>
          <div class="py-1">
            <bar-chart
              :ref="'UPSUtilizationChart-' + index"
              style="width: 99%;"
              :height="260"
              :chart-data="util.dataCollection"
              :options="chartOptionsUPSUtilization"
            />
          </div>
        </div>
      </div>
      <div class="mt-4 mb-2 ml-1 text-base font-bold">{{ location === 'PDC' ? 'CRAC' : 'A/C' }} INFORMATION</div>
      <!-- CRAC/AC Information Table -->
      <div>
        <table class="w-full">
          <thead>
            <tr class="bg-gray-300">
              <th class="px-2 py-1 text-left">{{ location === 'PDC' ? 'CRAC' : 'A/C' }}</th>
              <th class="px-2 text-left" v-for="pacIndex of 6" :key="pacIndex">
                #{{ pacIndex }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-gray-200">
              <td class="px-2 py-1">Return</td>
              <td v-for="index of 6" :key="index" class="px-2">- &deg;C</td>
            </tr>
            <tr class="bg-gray-300">
              <td class="px-2 py-1">Supply</td>
              <td v-for="index of 6" :key="index" class="px-2">- &deg;C</td>
            </tr>
            <tr class="bg-gray-200">
              <td class="px-2 py-1">Range</td>
              <td v-for="index of 6" :key="index" class="px-2">- &deg;C</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- CRAC Information Chart -->
      <div class="mt-5">
        <div class="my-2">Cooling Capacity</div>
        <bar-chart
          style="width: 99%;"
          :height="80"
          :chart-data="dataCollectionCooling"
          :options="chartOptionsCooling"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from './LineChart.js'
import BarChart from './BarChart.js'
import DoughnutChart from './DoughnutChart.js'
import SvgMap from '@/components/Portal/SvgMap'
import TempAndHumidTrends from './TempAndHumidTrends'
import { Splide, SplideSlide } from '@splidejs/vue-splide'

export default {
  components: {
    LineChart,
    BarChart,
    DoughnutChart,
    SvgMap,
    Splide,
    SplideSlide,
    TempAndHumidTrends
  },
  data() {
    return {
      // lineTrendChartVisible: [0, 0],
      upsUtils: [],
      viewBox: '',
      loading: false,
      chartLineTrendVisible: true,
      mapData: [],
      mapId: '',
      chartDoughnutConsumptionVisible: true,
      doughnutConsumptionInfo: [
        { consumed: 0, available: 0 },
        { consumed: 0, available: 0 }
      ],
      dataCollectionLineBTR: {},
      chartOptionsLineBTR: {
        plugins: {
          datalabels: {
            display: false
          }
        },
        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 20
          }
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Min'
              },
              ticks: {
                suggestedMin: 400,
                suggestedMax: 600
              }
            }
          ]
        }
      },
      dataCollectionUPSUtilization: {},
      chartOptionsUPSUtilization: {
        plugins: {
          datalabels: {
            display: false,
            color: 'white',
            formatter: function (value) {
              return value + '%'
            }
          }
        },
        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 20
          }
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: '%'
              },
              // ticks: {
              //   max: 32,
              //   beginAtZero: true,
              //   stepSize: 2 
              // }
            }
          ],
          xAxes: [
            {
              stacked: true,
              ticks: {
                stepSize: 1
              }
            }
          ]
        }
      },
      dataCollectionCooling: {},
      chartOptionsCooling: {
        plugins: {
          datalabels: {
            display: false
          }
        },
        legend: {
          position: 'bottom'
        },
        scales: {
          yAxes: [
            {
              ticks: {
                max: 100,
                stepSize: 20,
                beginAtZero: true
              }
            }
          ],
          xAxes: [
            {
              stacked: true,
              ticks: {
                stepSize: 1
              }
            }
          ]
        }
      },
      dataCollectionDoughnuts: [{}, {}],
      chartOptionsDoughnut: {
        plugins: {
          datalabels: {
            color: 'white'
          }
        },
        legend: {
          position: 'bottom',
          display: false
        }
      },
      timeRemainingDetail: {
        min: 0,
        max: 0,
        avg: 0
      },
      leakStatus: 'NO LEAKS',
      fetchingCharDataInterval: null,
      fetchingLeakStatus: null
    }
  },
  mounted() {
    this.loading = true

    this.getLeakStatus()
    this.fillChartData()
    
    this.fetchingCharDataInterval = setInterval(_ => {
      this.getAndFillDataTimeRemaining()
      this.getAndFillUPSUtilization()
    }, 300000)

    this.fetchingLeakStatus = setInterval(_ => {
      this.getLeakStatus()
    }, 60000);

    this.getMapData()

    setTimeout(() => {
      this.loading = false
    }, 2000)
  },
  computed: {
    query: function () {
      return this.$route.query
    },
    location: function () {
      return this.$route.query.location
    }
  },
  watch: {
    query: function (val) {
      // Activate loading so it looks like reloading, then re-fillChartData()
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.getMapData()
        this.fillChartData()
        this.getLeakStatus()
      }, 2000)
    },
  },
  methods: {
    lineTrendChartToggleOnClick(index) {
      this.lineTrendChartVisible[index] = index
      this.chartLineTrendVisible = false
      this.chartLineTrendVisible = true
    },
    getLeakClass(leakStatus) {
      if (leakStatus === 'NO LEAKS') return 'text-green-500'
      return 'text-red-500 text-sm'
    },
    getLeakStatus() {
      this.leakStatus = 'NO LEAKS'
      // console.log('ini lokasi', this.location)
      if (this.location === 'THMO') {
        this.fetchLeakPicmo()
      } else {
        this.fetchLeakPDC()
      }
    },
    async fetchLeakPDC() {
      const res = await this.$axios.get('Alarms/GetWLDSPDC')
      if (res?.data?.ListAlarm?.length > 0) this.leakStatus = res?.data?.ListAlarm?.[0].Description
    },
    async fetchLeakPicmo() {
      const res = await this.$axios.get('Alarms/GetWLDSPicmo')
      if (res?.data?.ListAlarm?.length > 0) this.leakStatus = res?.data?.ListAlarm?.[0].Description
    },
    async fillChartData() {
      // Fill chart backup time remaining
      this.getAndFillDataTimeRemaining()

      // Fill chart UPS utilization
      this.getAndFillUPSUtilization()

      let labels = ['Pac 1', 'Pac 2', 'Pac 3', 'Pac 4', 'Pac 5', 'Pac 6']
      // if location is THMO change labels to #N
      if (this.location === 'THMO') labels = ['#1', '#2', '#3', '#4', '#5', '#6'] 
      // Bar Cooling Capacity
      this.dataCollectionCooling = {
        labels: labels,
        datasets: [
          {
            label: 'Capacity',
            backgroundColor: '#53A8D3',
            data: [0, 0, 0, 0, 0, 0]
          }
        ]
      }

      // Fill chart Doughnut
      this.getAndFillDataDoughnut(0)
      this.getAndFillDataDoughnut(1)
    },
    getRandomIntRange(min, max) {
      return Math.round(Math.random() * (max - min) + min)
    },
    async getMapData() {
      try {
        this.loading = true
        this.viewBox = ''
        const cage = await this.$axios.get(
          'MapSketch/GetDropdownByTypeAsset?type=server-room'
        )
        this.mapId = cage.data.find((x) => x.Code == this.$route.query.location)
        const res = await this.$axios.get(
          `MapSketch/GetAllChildrenAssetDCO?dcoId=${this.mapId.Value}`
        )
        this.mapData = res.data
        // get viewbox for map
        let dataCage = res.data.find((x) => x.Type == 'server-room')
        this.viewBox = `0 0 ${dataCage.CanvasWidth} ${dataCage.CanvasHeight}`
        this.loading = false
        console.log(this.viewBox)
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    async getAndFillDataDoughnut(index) {
      const endpoints = [
        'Uspace/RackAvailableStatusLocation',
        'Uspace/GetSumUSpaceWithLocation'
      ]

      try {
        const res = await this.$axios.get(endpoints[index])
        // set index by location
        const locationIndex = this.location === 'PDC' ? 0 : 1
        let data = []
        if (index === 0) {
          // Rack
          data = [
            res.data[locationIndex]?.AvailablePercent,
            res.data[locationIndex]?.ConsumedPercent
          ]
          this.doughnutConsumptionInfo[index] = {
            available: res.data[locationIndex]?.AvailablePercent,
            consumed: res.data[locationIndex]?.ConsumedPercent
          }
        } else {
          // USpace
          data = [
            res.data[locationIndex]?.USpacePercentFree,
            res.data[locationIndex]?.USpacePercen
          ]
          this.doughnutConsumptionInfo[index] = {
            available: res.data[locationIndex]?.USpacePercentFree,
            consumed: res.data[locationIndex]?.USpacePercen
          }
        }

        this.dataCollectionDoughnuts[index] = {
          labels: ['available', 'consumed'],
          datasets: [
            {
              backgroundColor: ['#4db6ac', '#9575cd'],
              data: [...data]
            }
          ]
        }

        this.chartDoughnutConsumptionVisible = false
        this.chartDoughnutConsumptionVisible = true
      } catch (err) {
        console.log(err)
      }
    },
    async getAndFillDataTimeRemaining() {
      try {
        const res = await this.$axios.get(
          'Dashboard/GetDashboardScreenData?screen=UPSBattR'
        )

        let picmoSensors = []
        let PDCSensors = []
        if (this.location === 'PDC') {
          res.data[0].ListOfSensor.forEach((item) => {
            if (item.SubDeviceName === 'TCR UPS') PDCSensors.push(item)
          })
        } else {
          res.data[0].ListOfSensor.forEach((item) => {
            if (item.SubDeviceName === 'THMO UPS') picmoSensors.push(item)
          })
        }

        const listData = picmoSensors.map((sensor) => sensor.ListData)
        const mergedListData = [].concat(...listData)
        const listDateTime = picmoSensors.map((sensor) => sensor.ListDateTime)
        const mergedListDateTime = [].concat(...listDateTime)

        this.timeRemainingDetail.min = Math.min(...mergedListData)
        this.timeRemainingDetail.max = Math.max(...mergedListData)
        this.timeRemainingDetail.avg = Math.floor(
          mergedListData.reduce((a, b) => a + b, 0) / mergedListData.length
        )

        this.dataCollectionLineBTR = {
          labels: mergedListDateTime,
          datasets: [
            {
              label: res.data[0].ListOfSensor[0].SensorName,
              backgroundColor: '#EFAA21',
              borderColor: '#EFAA21',
              data: res.data[0].ListOfSensor[0].ListData,
              fill: false,
              lineTension: 0,
              pointRadius: 1,
              borderWidth: 1
            }
          ]
        }

        // Jika PDC tambahkan 1 upsUtil, dengan data kosong
        if (this.location === 'PDC') {
          this.dataCollectionLineBTR = {
            labels: [],
            datasets: [
              {
                label: 'Battery Time Remaining',
                backgroundColor: '#EFAA21',
                borderColor: '#EFAA21',
                data: [],
                fill: false
              }
            ]
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    // getAndFillDataTimeRemaining2() {
    //   this.$axios
    //     .get('Dashboard/GetDashboardScreenData?screen=UPSBattR')
    //     .then((result) => {
    //       const combinedListData = [
    //         ...result.data[0]?.ListOfSensor[0].ListData,
    //         ...result.data[0]?.ListOfSensor[1].ListData
    //       ]
    //       this.timeRemainingDetail.min = Math.min(...combinedListData)
    //       this.timeRemainingDetail.max = Math.max(...combinedListData)
    //       this.timeRemainingDetail.avg = Math.floor(
    //         combinedListData.reduce((a, b) => a + b, 0) /
    //           combinedListData.length
    //       )

    //       this.dataCollectionLineBTR = {
    //         labels: result.data[0].ListOfSensor[0].ListDateTime,
    //         datasets: [
    //           {
    //             label: result.data[0].ListOfSensor[0].SensorName,
    //             backgroundColor: '#EFAA21',
    //             borderColor: '#EFAA21',
    //             data: result.data[0].ListOfSensor[0].ListData,
    //             fill: false
    //           },
    //           {
    //             label: result.data[0].ListOfSensor[1].SensorName,
    //             backgroundColor: '#E62E2D',
    //             borderColor: '#E62E2D',
    //             data: result.data[0].ListOfSensor[1].ListData,
    //             fill: false
    //           }
    //         ]
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    // },
    async getAndFillUPSUtilization() {
      const res = await this.$axios.get(
        'Dashboard/GetDashboardScreenData?screen=UPSUtil'
      )

      const getUpsUtils = (sensors) => {
        let upsUtils = []

        sensors.forEach((sensor) => {
          const capacities = sensor.ListData.map((x) => 100)

          upsUtils.push({
            label: sensor.DeviceDceName,
            dataCollection: {
              labels: sensor.ListDateTime,
              datasets: [
                {
                  label: 'Consumption',
                  backgroundColor: '#ff9800',
                  // data: sensor.ListData
                  data: sensor.ListData.map(x => (x / 32 * 100).toFixed(2))
                },
                {
                  label: 'Capacity',
                  backgroundColor: '#c8e6c9',
                  data: [...capacities]
                }
              ]
            }
          })
        })

        return upsUtils
      }

      let PDCSensors = []
      let picmoSensors = []
      if (this.location === 'PDC') {
        res.data[0].ListOfSensor.forEach((item) => {
          if (item.SubDeviceName === 'UPS UPS') PDCSensors.push(item)
        })
        this.upsUtils = getUpsUtils(PDCSensors)
      } else {
        res.data[0].ListOfSensor.forEach((item) => {
          if (item.SubDeviceName === 'THMO UPS') picmoSensors.push(item)
        })
        this.upsUtils = getUpsUtils(picmoSensors)
      }
    },
    // getAndFillUPSUtilization2() {
    //   this.$axios
    //     .get('Dashboard/GetDashboardScreenData?screen=UPSUtil')
    //     .then((result) => {
    //       // Set UPS 1 utilization
    //       const dataCollectionUPSUtilizationCapacity =
    //         Math.max(...result.data[0].ListOfSensor[0].ListData) + 10
    //       this.dataCollectionUPSUtilization = {
    //         labels: result.data[0].ListOfSensor[0].ListDateTime,
    //         datasets: [
    //           {
    //             label: 'Consumption',
    //             backgroundColor: '#337130',
    //             data: result.data[0].ListOfSensor[0].ListData
    //           },
    //           {
    //             label: 'Capacity',
    //             backgroundColor: '#50A923',
    //             data: [
    //               ...Array(
    //                 result.data[0].ListOfSensor[0].ListData.length
    //               ).keys()
    //             ].map((i) => dataCollectionUPSUtilizationCapacity)
    //           }
    //         ]
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    // }
  },
  beforeDestroy() {
    clearInterval(this.fetchingCharDataInterval)
    clearInterval(this.fetchingLeakStatus)
  }
}
</script>
